export default class RecommendSpotCard {
  constructor({ elm, app }) {
    this.elm = elm;
    this.app = app;

    this.elm.addEventListener('click', () => {
      if (this.elm.classList.contains('is-selected')) {
        this.inactive();
        return;
      }

      const selectedCardsCount =
        this.app.recommendSpotCards.filter(card => card.elm.classList.contains('is-selected')).length;

      if (selectedCardsCount >= 2) { return; }

      this.active();
    });
  }

  active() {
    this.elm.classList.add(this.app.activeClassName);
  }

  inactive() {
    this.elm.classList.remove(this.app.activeClassName);
  }
}
